import React from 'react';
import { Alert } from 'antd';

import { get, getVal } from '../../../../../../shared/helpers';
import {
    checkCurrentStatusForHotList,
    checkDivisionForHotList,
    checkLastValuationForHotList,
    checkLeadCreatedDate,
} from './helpers';

const HotOrColdListAlert = ({
    bikeDetails, leadCreatedDate, valuations, currentStatusId, leadMarketing,
}) => {
    if (get(bikeDetails, 'ref_bike_variant.is_hot')
        && checkLeadCreatedDate(leadCreatedDate)
        && checkLastValuationForHotList(valuations)
        && checkCurrentStatusForHotList(currentStatusId)
        && checkDivisionForHotList(leadMarketing)
    ) {
        if (getVal(bikeDetails, 'ref_bike_variant.hot_margin')) {
            return (
                <Alert
                    style={{ marginBottom: 10 }}
                    message={`This bike is on the Hot List. The bike should have a margin of £${getVal(bikeDetails, 'ref_bike_variant.hot_margin') || 'not set'}`}
                    type="info"
                    showIcon
                />
            );
        }
    } else if (get(bikeDetails, 'ref_bike_model.we_dont_want')) {
        return (
            <Alert
                style={{ marginBottom: 10 }}
                message="Warning - This is a bike we never want to buy"
                type="warning"
                showIcon
            />
        );
    } else if (get(bikeDetails, 'ref_bike_variant.is_no_buy')) {
        if (getVal(bikeDetails, 'ref_bike_variant.cold_margin')) {
            return (
                <Alert
                    style={{ marginBottom: 10 }}
                    message={`Warning - This bike is a poor selling bike - must have £${getVal(bikeDetails, 'ref_bike_variant.cold_margin') || 'not set'}  margin if buying`}
                    type="warning"
                    showIcon
                />
            );
        }
    }

    return null;
};

export default HotOrColdListAlert;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/Alerts/HotOrColdListAlert.js